import { coreAxios } from "@/declare/api/axios"
import { Section } from "@/declare/interface/project/section"
import { AxiosResponse } from "axios"


/**
 * 获得系统截面大类
 * 
 * @return
 */
export function findSectionCategoryList(isTree?: boolean, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/sections/categories`, {
        params: {
            ...params,
            isTree: isTree,
        }
    })
}

/**
 * 获得系统截面标准列表
 * @return
 */
export function findSectionSources(params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/sections/sources`, {
        params: {
            ...params,
        }
    })
}

/**
 * 获取系统截面
 *
 * @param type
 * @return
 */
export function findSectionList(type?: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/sections`, {
        params: {
            ...params,
            type: type,
        }
    })
}
/**
 * 删除截面
 *
 * @param sectionId 截面id
 * @return
 */
export function deleteSection(sectionId: string, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.delete(`/sections/${sectionId}`, {
        params: {
            ...params,
        }
    })
}
/**
 * 新增截面
 *
 * @param section 截面信息
 * @return
 */
export function createSection(section: Section[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/sections`, section, {
        params: {
            ...params,
        }
    })
}

/**
 * 根据截面ids获得截面列表
 *
 * @param sectionIds 截面Ids
 * @return
 */
export function findSectionsByIds(sectionIds: string[], params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.post(`/sections/multi-get`, sectionIds, {
        params: {
            ...params,
        }
    })
}

/**
 * 修改截面
 *
 * @param sectionId
 * @param section
 * @return
 */
export function getSystemSectionParamIns(sectionId: string, section: any, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.put(`/sections/${sectionId}`, section, {
        params: {
            ...params,
        }
    })
}
/**
 * 获取截面详情
 *
 * @param sectionId
 * @param materialId 材料id
 * @return
 */
export function findSection(sectionId: string, materialId?: number, params?: {}): Promise<AxiosResponse<any>> {
    return coreAxios.get(`/sections/${sectionId}`, {
        params: {
            ...params,
            materialId: materialId,
        }
    })
}